<template>
  <v-card class="mt-0" outlined :loading="loading">
    <v-card-title class="justify-center"> Activity Revenue (YTD) </v-card-title>
    <v-card-text>
      <template>
        <div>
          <vue-apex-charts
            type="area"
            :options="chartOptions"
            :series="series"
            :height="240"
          ></vue-apex-charts>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {
  startOfTomorrow,
  startOfMonth,
  subMonths,
  format,
  parseISO
} from "date-fns";
import { getActivityRevenueGraph } from "../../api/report";
import { formatDollarCents } from "../../common/format";

export default {
  name: "ActivityRevenueGraph",

  components: { VueApexCharts },

  data() {
    return {
      loading: false,
      periods: [],
      series: []
    };
  },

  computed: {
    chartOptions() {
      const periods = this.periods;
      return {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: true
        },
        stroke: {
          curve: "straight"
        },
        tooltip: {
          enabled: true,
          shared: true
        },
        xaxis: {
          categories: periods
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter: value => formatDollarCents(value)
          }
        }
      };
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(
      startDate = startOfMonth(subMonths(new Date(), 12)),
      endDate = startOfTomorrow()
    ) {
      try {
        this.loading = true;

        const result = await getActivityRevenueGraph(startDate, endDate);
        this.periods = result.items.map(item =>
          format(parseISO(item.date), "MMM")
        );
        this.series = [
          {
            name: "Total",
            data: result.items.map(item => item.total)
          },
          {
            name: "Helpline USA",
            data: result.items.map(item => item.helplineUSA)
          },
          {
            name: "Helpline Canada",
            data: result.items.map(item => item.helplineCA)
          },
          {
            name: "Premium Calls",
            data: result.items.map(item => item.calls)
          },
          {
            name: "Premium Clicks",
            data: result.items.map(item => item.clicks)
          }
        ];
      } catch (e) {
        console.error("ERROR IN ACTIVITY REVENUE GRAPH", e);
      }

      this.loading = false;
    }
  }
};
</script>
